import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateGuardian as apiUpdate } from "../../api/apiGuardians";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useUpdateGuardian() {
    const navigate = useNavigate(); const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: editGuardian, isPending: isUpdate, error } = useMutation({ mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["guardians"] }); navigate('/guardians'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { editGuardian, isUpdate, error };
}
